import Constants from 'expo-constants'
import jsonp from 'jsonp'

import { addBreadcrumb } from '../utils/sentry'

const extra = Constants.expoConfig?.extra as
  | {
      mailchimp?: { baseUrl?: string }
      build?: { flavour?: string }
    }
  | undefined

const mailchimpBaseUrl: string | undefined = extra?.mailchimp?.baseUrl
const isProd = extra?.build?.flavour === 'prod'

/**
 * Subscribe a new user to the Mailchimp audience via JSONP.
 * Web must use JSONP because the Mailchimp embed endpoint does not send
 * CORS headers, so browser `fetch` is blocked.
 *
 * Only runs in production builds (flavour === 'prod', not __DEV__).
 * The call is fire-and-forget: failures are logged but never thrown.
 */
export function sendNewSubscriber(email: string, name: string): void {
  if (__DEV__ || !isProd || !mailchimpBaseUrl) {
    return
  }

  const encode = encodeURIComponent
  const url =
    `${mailchimpBaseUrl}&EMAIL=${encode(email)}&FNAME=${encode(name)}`.replace(
      '/post?',
      '/post-json?',
    )

  jsonp(url, { param: 'c' }, (err) => {
    if (err) {
      console.warn('Mailchimp subscription failed', err)
      addBreadcrumb('mailchimp', 'subscription_failed', { error: String(err) })
    } else {
      addBreadcrumb('mailchimp', 'subscription_sent')
    }
  })
}
